"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWoodenBox = void 0;
const Design_1 = require("./Design");
const Layer_1 = require("./layers/Layer");
const typeguard_1 = require("../types/typeguard");
const TemplateSurface_1 = require("./TemplateSurface");
const sizeRuleSet = {
  width: typeguard_1.isNumber,
  height: typeguard_1.isNumber
};
const isSize = s => (0, typeguard_1.isType)(s, sizeRuleSet);
const woodenBoxRuleSet = {
  design: Design_1.isDesign,
  layers: value => Array.isArray(value) && value.every(Layer_1.isLayer),
  surface: TemplateSurface_1.isTemplateSurface,
  size: isSize
};
const isWoodenBox = wb => (0, typeguard_1.isType)(wb, woodenBoxRuleSet);
exports.isWoodenBox = isWoodenBox;